import { render, staticRenderFns } from "./SowTypeTableSkeleton.vue?vue&type=template&id=4caf3fef"
import script from "./SowTypeTableSkeleton.vue?vue&type=script&lang=js"
export * from "./SowTypeTableSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports